import React from 'react';

import Unibrow from 'js/design_system/Unibrow';
import routes from 'js/core_pre_webpack/routes';
import UploadIllustration from './illustrations/upload_illustration.svg';

const UploadEncouragementUnibrow: React.FC = () => {
  return (
    <Unibrow
      dismissibleName="UploadEncouragementUnibrow"
      text="Papers uploaded to Academia get 69% more citations."
      primaryButton={{
        text: 'Upload your papers now',
        onClick: () => {
          window.location.href = routes.upload_funnel_document_path();
        },
        iconRight: 'arrow_forward',
      }}
      icon={<UploadIllustration size={40} />}
    />
  );
};

export default UploadEncouragementUnibrow;
